import { useFormikContext } from "formik";
import { EstadoTramite, TipoTramite } from "../utils/enums";
import {
  isAcopioLiquidosFormInvalid,
  isAcopioSolidosFormInvalid,
  isActividadFormInvalid,
  isDestinoEfluentesFormInvalid,
  isEfluenteCrudoFormInvalid,
  isEmisionesGaseosasFormInvalid,
  isEmpresaFormInvalid,
  isEstablecimientoFormInvalid,
  isFuentesFijasFormInvalid,
  isImpactoAmbientalFormInvalid,
  isInfraestructuraFormInvalid,
  isInvalidAdjuntosForm,
  isOperacionesUnitariasFormInvalid,
  isOrigenEfluentesFormInvalid,
  isProduccionFormInvalid,
  isRegimenLaboralFormInvalid,
  isRepresentanteLegalFormInvalid,
  isRepresentanteTecnicoFormInvalid,
  isResiduosPatogenicosFormInvalid,
  isResiduosPeligrososFormInvalid,
  isResiduosSolidosUrbanosFormInvalid,
  isResiduosTratamientoFormInvalid,
  isSustanciasQuimicasFormInvalid,
  isTransformadoresPCBFormInvalid,
  isTratamientoEfluentesFormInvalid,
  isTratamientoExternoFormInvalid,
} from "../utils/tramite";
import { t } from "i18next";
import AcopioLiquidosForm from "./AcopioLiquidosForm";
import AcopioSolidosForm from "./AcopioSolidosForm";
import ActividadForm from "./ActividadForm";
import AdjuntosForm from "./AdjuntosForm";
import DestinoEfluentesForm from "./DestinoEfluentesForm";
import EfluenteCrudoForm from "./EfluenteCrudoForm";
import EmisionesGaseosasForm from "./EmisionesGaseosasForm";
import EmpresaForm from "./EmpresaForm";
import EstablecimientoForm from "./EstablecimientoForm";
import FuentesFijasForm from "./FuentesFijasForm";
import ImpactoAmbientalForm from "./ImpactoAmbientalForm";
import InformacionTramite from "./InformacionTramite";
import InfraestructuraForm from "./InfraestructuraForm";
import OperacionesUnitariasForm from "./OperacionesUnitariasForm";
import OrigenEfluentesForm from "./OrigenEfluentesForm";
import ProduccionForm from "./ProduccionForm";
import RegimenLaboralForm from "./RegimenLaboralForm";
import RepresentanteLegalForm from "./RepresentanteLegalForm";
import RepresentanteTecnicoForm from "./RepresentanteTecnicoForm";
import ResiduosPatogenicosForm from "./ResiduosPatogenicosForm";
import ResiduosPeligrososForm from "./ResiduosPeligrososForm";
import ResiduosSolidosUrbanosForm from "./ResiduosSolidosUrbanosForm";
import ResiduosTratamientoForm from "./ResiduosTratamientoForm";
import SustanciasQuimicasForm from "./SustanciasQuimicasForm";
import TransformadoresPCBForm from "./TransformadoresPCBForm";
import TratamientoEfluentesForm from "./TratamientoEfluentesForm";
import TratamientosExternosForm from "./TratamientosExternosForm";
import Anchor from "./controls/Anchor";

export const INDICE = [
  {
    id: "modulo0",
    component: <InformacionTramite />,
    isInvalid: (tramiteForm) => false,
    isEnabled: (tramiteForm) => true,
  },
  {
    id: "modulo1",
    isInvalid: (tramiteForm) => {
      return (
        isEmpresaFormInvalid(tramiteForm) ||
        isEstablecimientoFormInvalid(tramiteForm) ||
        isActividadFormInvalid(tramiteForm) ||
        isRepresentanteLegalFormInvalid(tramiteForm) ||
        isRepresentanteTecnicoFormInvalid(tramiteForm) ||
        isImpactoAmbientalFormInvalid(tramiteForm)
      );
    },
    isEnabled: (tramiteForm) => {
      return (
        [TipoTramite.DJE, TipoTramite.DJG].indexOf(
          tramiteForm.values.tipo?.codigo,
        ) >= 0
      );
    },
    secciones: [
      {
        id: "empresa",
        component: <EmpresaForm />,
        isInvalid: isEmpresaFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            [TipoTramite.DJE, TipoTramite.DJG].indexOf(
              tramiteForm.values.tipo?.codigo,
            ) >= 0
          );
        },
      },
      {
        id: "establecimiento",
        component: <EstablecimientoForm />,
        isInvalid: isEstablecimientoFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            [TipoTramite.DJE, TipoTramite.DJG].indexOf(
              tramiteForm.values.tipo?.codigo,
            ) >= 0
          );
        },
      },
      {
        id: "actividad",
        component: <ActividadForm />,
        isInvalid: isActividadFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            [TipoTramite.DJE, TipoTramite.DJG].indexOf(
              tramiteForm.values.tipo?.codigo,
            ) >= 0
          );
        },
      },
      {
        id: "representanteLegal",
        component: <RepresentanteLegalForm />,
        isInvalid: isRepresentanteLegalFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            [TipoTramite.DJE, TipoTramite.DJG].indexOf(
              tramiteForm.values.tipo?.codigo,
            ) >= 0
          );
        },
      },
      {
        id: "representanteTecnico",
        component: <RepresentanteTecnicoForm />,
        isInvalid: isRepresentanteTecnicoFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            [TipoTramite.DJE, TipoTramite.DJG].indexOf(
              tramiteForm.values.tipo?.codigo,
            ) >= 0
          );
        },
      },
      {
        id: "impactoAmbiental",
        component: <ImpactoAmbientalForm />,
        isInvalid: isImpactoAmbientalFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            [TipoTramite.DJE, TipoTramite.DJG].indexOf(
              tramiteForm.values.tipo?.codigo,
            ) >= 0
          );
        },
      },
    ],
  },
  {
    id: "modulo2",
    isInvalid: (tramiteForm) => {
      return (
        isOperacionesUnitariasFormInvalid(tramiteForm) ||
        isProduccionFormInvalid(tramiteForm) ||
        isSustanciasQuimicasFormInvalid(tramiteForm) ||
        isRegimenLaboralFormInvalid(tramiteForm) ||
        isInfraestructuraFormInvalid(tramiteForm)
      );
    },
    isEnabled: (tramiteForm) => {
      return (
        [TipoTramite.DJA, TipoTramite.DJG].indexOf(
          tramiteForm.values.tipo?.codigo,
        ) >= 0
      );
    },
    secciones: [
      {
        id: "operacionesUnitarias",
        component: <OperacionesUnitariasForm />,
        isInvalid: isOperacionesUnitariasFormInvalid,
        isEnabled: (tramiteForm) => {
          return tramiteForm.values.tipo?.codigo === TipoTramite.DJG;
        },
      },
      {
        id: "produccion",
        component: <ProduccionForm />,
        isInvalid: isProduccionFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            [TipoTramite.DJA, TipoTramite.DJG].indexOf(
              tramiteForm.values.tipo?.codigo,
            ) >= 0
          );
        },
      },
      {
        id: "sustanciasQuimicas",
        component: <SustanciasQuimicasForm />,
        isInvalid: isSustanciasQuimicasFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            [TipoTramite.DJA, TipoTramite.DJG].indexOf(
              tramiteForm.values.tipo?.codigo,
            ) >= 0
          );
        },
      },
      {
        id: "regimenLaboral",
        component: <RegimenLaboralForm />,
        isInvalid: isRegimenLaboralFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            [TipoTramite.DJA, TipoTramite.DJG].indexOf(
              tramiteForm.values.tipo?.codigo,
            ) >= 0
          );
        },
      },
      {
        id: "infraestructura",
        component: <InfraestructuraForm />,
        isInvalid: isInfraestructuraFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            [TipoTramite.DJA, TipoTramite.DJG].indexOf(
              tramiteForm.values.tipo?.codigo,
            ) >= 0
          );
        },
      },
    ],
  },
  {
    id: "modulo3",
    isInvalid: (tramiteForm) => {
      return (
        isOrigenEfluentesFormInvalid(tramiteForm) ||
        isTratamientoEfluentesFormInvalid(tramiteForm) ||
        isEfluenteCrudoFormInvalid(tramiteForm) ||
        isDestinoEfluentesFormInvalid(tramiteForm) ||
        isTratamientoExternoFormInvalid(tramiteForm) ||
        isResiduosTratamientoFormInvalid(tramiteForm)
      );
    },
    isEnabled: (tramiteForm) => {
      return (
        tramiteForm.values.tipo?.codigo === TipoTramite.DJEELL ||
        (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
          tramiteForm.values.conEfluentesLiquidos)
      );
    },
    secciones: [
      {
        id: "origenEfluentes",
        component: <OrigenEfluentesForm />,
        isInvalid: isOrigenEfluentesFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            tramiteForm.values.tipo?.codigo === TipoTramite.DJEELL ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conEfluentesLiquidos)
          );
        },
      },
      {
        id: "tratamientoEfluentes",
        component: <TratamientoEfluentesForm />,
        isInvalid: isTratamientoEfluentesFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            tramiteForm.values.tipo?.codigo === TipoTramite.DJEELL ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conEfluentesLiquidos)
          );
        },
      },
      {
        id: "efluenteCrudo",
        component: <EfluenteCrudoForm />,
        isInvalid: isEfluenteCrudoFormInvalid,
        isEnabled: (tramiteForm) => {
          if (
            tramiteForm.values.tipo?.codigo === TipoTramite.DJEELL ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conEfluentesLiquidos &&
              tramiteForm.values.plantasTratamiento?.length > 0)
          ) {
            const tecnologias = [];
            tramiteForm.values.plantasTratamiento.forEach((planta) =>
              tecnologias.push(...planta.tecnologias),
            );
            return (
              tecnologias.filter((tecnologia) => tecnologia.nivel >= 1).length >
              0
            );
          }
          return false;
        },
      },
      {
        id: "destinoEfluentes",
        component: <DestinoEfluentesForm />,
        isInvalid: isDestinoEfluentesFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            tramiteForm.values.tipo?.codigo === TipoTramite.DJEELL ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conEfluentesLiquidos)
          );
        },
      },
      {
        id: "tratamientoExterno",
        component: <TratamientosExternosForm />,
        isInvalid: isTratamientoExternoFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJEELL ||
              (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
                tramiteForm.values.conEfluentesLiquidos)) &&
            tramiteForm.values.conTratamientoExterno
          );
        },
      },
      {
        id: "residuosTratamiento",
        component: <ResiduosTratamientoForm />,
        isInvalid: isResiduosTratamientoFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJEELL ||
              (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
                tramiteForm.values.conEfluentesLiquidos)) &&
            tramiteForm.values.plantasTratamiento?.length > 0
          );
        },
      },
    ],
  },
  {
    id: "modulo4",
    isInvalid: (tramiteForm) => {
      return (
        isResiduosSolidosUrbanosFormInvalid(tramiteForm) ||
        isResiduosPeligrososFormInvalid(tramiteForm) ||
        isResiduosPatogenicosFormInvalid(tramiteForm) ||
        isTransformadoresPCBFormInvalid(tramiteForm)
      );
    },
    isEnabled: (tramiteForm) => {
      return (
        tramiteForm.values.tipo?.codigo === TipoTramite.DJRR ||
        (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
          (tramiteForm.values.conResiduosPeligrosos ||
            tramiteForm.values.conResiduosPatogenicos ||
            tramiteForm.values.conResiduosSolidosUrbanos ||
            tramiteForm.values.conEquiposPCB))
      );
    },
    secciones: [
      {
        id: "residuosSolidosUrbanos",
        component: <ResiduosSolidosUrbanosForm />,
        isInvalid: isResiduosSolidosUrbanosFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJRR &&
              tramiteForm.values.establecimiento?.conResiduosSolidosUrbanos) ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conResiduosSolidosUrbanos)
          );
        },
      },
      {
        id: "residuosPeligrosos",
        component: <ResiduosPeligrososForm />,
        isInvalid: isResiduosPeligrososFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJRR &&
              tramiteForm.values.establecimiento?.conResiduosPeligrosos) ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conResiduosPeligrosos)
          );
        },
      },
      {
        id: "residuosPatogenicos",
        component: <ResiduosPatogenicosForm />,
        isInvalid: isResiduosPatogenicosFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJRR &&
              tramiteForm.values.establecimiento?.conResiduosPatogenicos) ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conResiduosPatogenicos)
          );
        },
      },
      {
        id: "transformadoresPCB",
        component: <TransformadoresPCBForm />,
        isInvalid: isTransformadoresPCBFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJRR &&
              tramiteForm.values.establecimiento?.conEquiposPCB) ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conEquiposPCB)
          );
        },
      },
    ],
  },
  {
    id: "modulo5",
    isInvalid: (tramiteForm) => {
      return (
        isFuentesFijasFormInvalid(tramiteForm) ||
        isAcopioLiquidosFormInvalid(tramiteForm) ||
        isAcopioSolidosFormInvalid(tramiteForm)
      );
    },
    isEnabled: (tramiteForm) => {
      return (
        tramiteForm.values.tipo?.codigo === TipoTramite.DJEEGG ||
        (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
          tramiteForm.values.conEmisionesGaseosas)
      );
    },
    secciones: [
      {
        id: "emisionesGaseosas",
        component: <EmisionesGaseosasForm />,
        isInvalid: isEmisionesGaseosasFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            tramiteForm.values.tipo?.codigo === TipoTramite.DJEEGG ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conEmisionesGaseosas)
          );
        },
      },
      {
        id: "fuentesFijas",
        component: <FuentesFijasForm />,
        isInvalid: isFuentesFijasFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            tramiteForm.values.tipo?.codigo === TipoTramite.DJEEGG ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conEmisionesGaseosas)
          );
        },
      },
      {
        id: "acopioLiquidos",
        component: <AcopioLiquidosForm />,
        isInvalid: isAcopioLiquidosFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            tramiteForm.values.tipo?.codigo === TipoTramite.DJEEGG ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conEmisionesGaseosas)
          );
        },
      },
      {
        id: "acopioSolidos",
        component: <AcopioSolidosForm />,
        isInvalid: isAcopioSolidosFormInvalid,
        isEnabled: (tramiteForm) => {
          return (
            tramiteForm.values.tipo?.codigo === TipoTramite.DJEEGG ||
            (tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
              tramiteForm.values.conEmisionesGaseosas)
          );
        },
      },
    ],
  },
  {
    id: "modulo6",
    component: <AdjuntosForm />,
    isInvalid: isInvalidAdjuntosForm,
    isEnabled: (tramiteForm) => {
      return (
        tramiteForm.values.tipo?.codigo === TipoTramite.DJG &&
        [
          EstadoTramite.FINALIZADO,
          EstadoTramite.PRESENTADO,
          EstadoTramite.APROBADO,
        ].indexOf(tramiteForm.values.estado?.codigo) >= 0
      );
    },
  },
];

export default function TramiteIndex({
  moduloActivo,
  seccionActiva,
  setModuloActivo,
  setSeccionActiva,
}) {
  const tramiteForm = useFormikContext();
  const handleIndiceClick = (modulo, seccion) => (event) => {
    event.preventDefault();
    setModuloActivo((anterior) =>
      !seccion && anterior?.id === modulo.id ? anterior : modulo,
    );
    setSeccionActiva((anterior) =>
      !modulo.secciones
        ? null
        : !seccion
        ? null
        : anterior?.id === seccion.id
        ? anterior
        : seccion,
    );
  };
  return (
    <ul className="nav nav-stacked" style={{ marginTop: 0 }}>
      {INDICE.map((modulo) => (
        <li>
          {(!!modulo.secciones && modulo.secciones.length > 0 && (
            <>
              <Anchor
                className={[
                  "text-small",
                  (modulo.isInvalid(tramiteForm) && "has-error") || "",
                ]
                  .join(" ")
                  .trim()}
                aria-expanded={moduloActivo?.id === modulo.id}
                href={`#${modulo.id}_secciones`}
                onClick={handleIndiceClick(modulo)}
                disabled={!modulo.isEnabled(tramiteForm)}
              >
                <strong>
                  {t(`tramiteForm.indice.${modulo.id}.titulo`).toUpperCase()}
                  &nbsp;-&nbsp;
                  {t(
                    `tramiteForm.indice.${modulo.id}.descripcion`,
                  ).toUpperCase()}
                </strong>
              </Anchor>
              <div
                className={[
                  "collapse",
                  "fade-in",
                  (moduloActivo?.id === modulo.id && "in") || "",
                ]
                  .join(" ")
                  .trim()}
                aria-expanded={moduloActivo?.id === modulo.id}
                id={`${modulo.id}_secciones`}
              >
                <ul
                  style={{ marginLeft: "8px" }}
                  className="nav nav-pills nav-stacked"
                >
                  {modulo.secciones.map((seccion) => (
                    <li>
                      <Anchor
                        onClick={handleIndiceClick(modulo, seccion)}
                        href={`#${modulo.id}_${seccion.id}`}
                        className={[
                          "text-small",
                          moduloActivo?.id === modulo.id &&
                          seccionActiva?.id === seccion.id
                            ? "active"
                            : "",
                          (seccion.isInvalid(tramiteForm) && "has-error") || "",
                        ]
                          .join(" ")
                          .trim()}
                        disabled={!seccion.isEnabled(tramiteForm)}
                      >
                        {t(
                          `tramiteForm.indice.${modulo.id}.${seccion.id}`,
                        ).toUpperCase()}
                      </Anchor>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )) || (
            <Anchor
              onClick={handleIndiceClick(modulo)}
              href={`#${modulo.id}`}
              className={[
                "text-small",
                (moduloActivo?.id === modulo.id && "active") || "",
                (modulo.isInvalid(tramiteForm) && "has-error") || "",
              ]
                .join(" ")
                .trim()}
              disabled={!modulo.isEnabled(tramiteForm)}
            >
              <strong>
                {t(`tramiteForm.indice.${modulo.id}.titulo`).toUpperCase()}
                &nbsp;-&nbsp;
                {t(`tramiteForm.indice.${modulo.id}.descripcion`).toUpperCase()}
              </strong>
            </Anchor>
          )}
        </li>
      ))}
    </ul>
  );
}
